module.exports = {
    APP_URL: 'http://mtg-booking.localhost:4000',
    API_URL: 'http://mtg-booking.localhost:8080',
    SOCKET_URL: 'http://mtg-booking.localhost:6001',
    SOCKET_APP_ID: 'VIAPLAY_SPORT_BOOKING',
    SOCKET_CLIENT_KEY: 'fa77cf3850f77861633c4386fc43b712'
}
